import { SystemField } from "./system-field";

export class SaleOrderDetail extends SystemField {
     
     products_id?:string;
     is_free?:number;
     warehouse_id?:string;
     uom_id?:string;
     quantity?:number;
     unit_price?:number;
     discount_code?:string;
     discount_rate?:number;
     discount_amount?:number;
     tax_category_id?:string;
     project_task_id?:string;
     sales_order_id?:string;
     shipped_qty?:number;
     ordering?:number;
     status?:string;
     unit_cost?:number;
     service_date?:string;
     pos_key?:string;
}
export class SaleOrderDetailTranslation extends SystemField{
      
      lang_code?:string;
      sale_desc?:string;
      sale_order_details_id?:string;
      short_desc?:string;
}
